module.exports = __webpack_public_path__ + "img/img16.b11fa65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img16.png
// module id = 256
// module chunks = 0